import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import style from './style.scss';
import comodo from 'assets/images/comodo.png';

const Footer = ({ isVisible = true }) => (
  // Global Footer
  <div id="Footer" className="footer-container footer-simple" data-sticky-footer>
    <div>
      <footer className="footer row">
        {
          isVisible && (
            <div className={style.footerContent}>
              <p>
                All loans through LendingUSA are made by its <a href="https://lendingusa.com/lending-partners/" className={style.footerCta} target="_blank" rel="noopener noreferrer">lending partners</a>. Minimum and maximum financed amounts vary by term and loan purpose. Loans are not available in all states. An origination fee of up to 8% may be included in the principal loan amount that may result in an APR of up to 35.99%.
              </p>
              <p>
                Your loan may have a No Interest on Principal Option Promotion included. This promotion can save you money if you pay off the principal amount of the loan in full within the Promotional Period (&apos;Promotional Period&apos;). During the Promotional Period you will be responsible for making all of your monthly payments and your loan will accrue interest on a monthly basis. If you pay off your loan within the Promotional Period, the monthly payments that you have made during this period, which includes accrued interest, will be deducted from the principal amount of the loan. Length of Promotional Periods vary, please review your loan agreement for full details.
              </p>
            </div>
          )
        }
        <div className={cn('legal grid-x', style.legal, !isVisible && style.noBorderTop)}>
          <div className={cn('cell medium-6 security', style.security)}>
            <img src={comodo} alt="Equal Housing Opportunity - Comodo" />
          </div>
          <div className={cn('cell medium-6 copyright', style.copyright)}>
            <div className="footer-copy"><p>Copyright © {new Date().getFullYear()}. LendingUSA, LLC. All Rights Reserved.</p></div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  // End Global Footer
);

Footer.propTypes = {
  isVisible: PropTypes.bool,
};

export default Footer;
